<div id="residency">
  <div name="main" class="p-8 flex flex-col sm:w-auto bg-white">
    <div class="md:px-16">
      <div>
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Lease Renewal</h2>
        </div>
        <div class="box-border-inactive">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/4</h2>
          </div>
          <div class="col-span-6">
            <h2 class="text-lg font-bold my-6 text-left">Contact Information</h2>
          </div>
          <div class="col-span-3 text-right">
            <button mat-flat-button color="accent" class="h-10 px-6 mt-6 text-right"
              routerLink="/renewalcog/renewal-review/contact-info" routerLinkActive="active">UPDATE</button>
          </div>
        </div>
        <div class="box-border-inactive">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/4</h2>
          </div>
          <div class="col-span-6">
            <h2 class="text-lg font-bold my-6">Other Occupant Information</h2>
            <p>Children and Pets</p>
          </div>
          <div class="col-span-3 text-right">
            <button mat-flat-button color="accent" class="h-10 px-6 mt-6 text-right"
              routerLink="/renewalcog/renewal-review/other-occupant" routerLinkActive="active">UPDATE</button>
          </div>
        </div>
        <div class="box-border-inactive">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">3/4</h2>
          </div>
          <div class="col-span-6">
            <h2 class="text-lg font-bold my-6">Current Employer</h2>
          </div>
          <div class="col-span-3 text-right">
            <button mat-flat-button color="accent" class="h-10 px-6 mt-6 text-right"
              routerLink="/renewalcog/renewal-review/employment-info" routerLinkActive="active">UPDATE</button>
          </div>
        </div>
        <div class="flex box-border-active pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">4/4</h2>
          </div>
          <div class="col-span-9">
            <h2 class="text-lg font-bold my-6">Renewal Plan</h2>
          </div>
        </div>
      </div>
      <div id="choose-info-contact" class="secondary">
        <div id="renewal-choose-plan-info" class="form-container">
          <div>
            <div>
              <div class="text-left text-lg">
                Please select a plan
              </div>
            </div>
            <div class="rounded-sm border w-full bg-white">
              <div class="flex flex-col border-gray-100">
                <div class="flex flex-row px-8 py-4 text-sm sm:text-base font-bold items-center">
                  <div class="flex flex-row w-1/3">
                    <div class="w-1/4">
                    </div>
                    <div class="w-3/4 flex">
                      Plan
                    </div>
                  </div>
                  <div class="w-1/3">
                    Renewal Lease Term
                  </div>
                  <div class="w-1/3">
                    New Base Rent
                  </div>
                </div>
                <div class="flex flex-row px-8 py-2 bg-beige-tricon text-sm sm:text-base border-t">
                  <div class="flex flex-row w-1/3">
                    <div class="w-1/4">
                      <mat-radio-group aria-labelledby="preferred plan option" [(ngModel)]="planType">
                        <mat-radio-button class="plan-radio-btn" value="premier">
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <div class="w-3/4">
                      Premier Plan
                    </div>
                  </div>
                  <div class="w-1/3">
                    <div class="planText" *ngIf="model.PremierPlan != null">
                      {{model.PremierPlan.RenewalLeaseTerm}} months
                    </div>
                  </div>
                  <div class="w-1/3">
                    <div class="planText" *ngIf="model.PremierPlan != null">
                      {{model.PremierPlan.NewRent | currency:'USD':true}} per month
                    </div>
                  </div>
                </div>
                <div class="flex flex-row px-8 py-2 text-sm sm:text-base border-t">
                  <div class="flex flex-row w-1/3">
                    <div class="w-1/4">
                      <mat-radio-group aria-labelledby="preferred plan option" [(ngModel)]="planType">
                        <mat-radio-button class="plan-radio-btn" value="preferred">
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <div class="w-3/4">
                      Preferred Plan
                    </div>
                  </div>
                  <div class="w-1/3">
                    <div class="planText" *ngIf="model.PremierPlan != null">
                      {{model.PreferredPlan.RenewalLeaseTerm}} months
                    </div>
                  </div>
                  <div class="w-1/3">
                    <div class="planText" *ngIf="model.PremierPlan != null">
                      {{model.PreferredPlan.NewRent | currency:'USD':true}} per month
                    </div>
                  </div>
                </div>
                <div class="flex flex-row px-8 py-2 bg-beige-tricon text-sm sm:text-base border-t">
                  <div class="flex flex-row w-1/3">
                    <div class="w-1/4">
                      <mat-radio-group *ngIf="!model.IsRentToPurchaseLease" aria-labelledby="flexible plan option" [(ngModel)]="planType">
                        <mat-radio-button class="plan-radio-btn" value="flexible">
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <div class="w-3/4">
                      Flexible Plan
                    </div>
                  </div>
                  <div class="w-1/3">
                    <div class="planText" *ngIf="model.PremierPlan != null && !model.IsRentToPurchaseLease">
                      Month-to-Month
                    </div>
                    <div class="planText" *ngIf="model.PremierPlan != null && model.IsRentToPurchaseLease">
                      12 months
                    </div>
                  </div>
                  <div class="w-1/3">
                    <div class="planText" *ngIf="model.PremierPlan != null">
                      {{model.FlexiblePlan.NewRent | currency:'USD':true}} per month
                    </div>
                  </div>
                </div>
                <div class="flex flex-row px-4 py-4 border-t">
                  <div class="w-full sm:flex justify-end ">
                    <button *ngIf="!planChosen" mat-flat-button color="accent" class="h-10 px-6 my-2"
                      [disabled]="planType === null" (click)="onSubmit()">CONFIRM SELECTION</button>
                    <button *ngIf="planChosen" mat-flat-button color="accent" class="h-10 px-6 my-2"
                      (click)="logOut()">RENEWAL DASHBOARD</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row chooseFlex chooseMinHeight">
              <div class="col-md-12 text-right mobile-button-center">
                <div *ngIf="model.FlexiblePlan != null">
                  *The Flexible Plan will automatically be chosen if another plan is not selected by
                  <b>{{model.FlexiblePlan.MTMActiveDate | date:'MM/dd/yyyy'}}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
